import React, { useEffect } from "react";
import classNames from "classnames";
import { IOpenMenu } from "../../components/Header/Header.types";
import "./burgerV0.sass";

export function BurgerV0({ isOpen, openMenuBurger }: IOpenMenu) {
  function handleClick() {
    openMenuBurger(!isOpen);
  }

  useEffect(() => {
    const body = document.querySelector("body");
    if (body) {
      isOpen ? body.classList.add("lock") : body.classList.remove("lock");
    }
  }, [isOpen]);
  return (
    <button
      type="button"
      className={classNames("burgerV0", isOpen ? "burgerV0_active" : "")}
      aria-label="Menu"
      onClick={handleClick}
    >
      <span></span>
      <span></span>
      <span></span>
    </button>
  );
}
